<template>
  <div>
    <v-row>
      <v-col cols="12" md="12">
        <v-hover v-slot="{ hover }">

          <v-card :style="{border: 'white'}"
                  :class="hover?'elevation-1 rounded-lg pa-5 glass-effect-hover':'elevation-1 rounded-lg pa-5 glass-effect'">
            <v-row>
              <v-card-title>
                <span class="white--text ml-2">{{ title }}</span>
              </v-card-title>

            </v-row>
            <v-row v-if="item.id">
              <v-col cols="12">
                <v-img
                    @click="change_logo_dialog = true"
                    class="mr-2"
                    style="cursor: pointer"
                    v-if="!item.logo"
                    contain
                    max-height="90"
                    max-width="90"
                    src="/img/user.png"
                />
                <v-avatar class="mr-2" v-if="item.logo" size="100" style="cursor: pointer"
                          @click="change_logo_dialog = true">
                  <v-img class="rounded-lg" :src="img_source(item.logo)"/>
                </v-avatar>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-autocomplete
                    class="rounded-lg"
                    :rules="[rules.required,]"
                    label="نوع کسب و کار"
                    :items="BUSINESS_TYPE"
                    v-model="item.business_type"
                    item-text="name"
                    item-value="value"
                    :disabled="!is_editing"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field label="* نام کسب و کار "
                              v-model="item.name" background-color="white" class="rounded-lg"
                              :disabled="!is_editing" :rules="[rules.required,]"/>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <user-select
                    user-type="buow"
                    class="rounded-lg"
                    label="صاحب کسب و کار"
                    v-model="item.admin = user.id"
                    :disabled="true"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field class="rounded-lg"
                              label="آدرس دامنه "
                              v-model="item.domain_address" background-color="white" :disabled="!is_editing"/>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field class="rounded-lg" v-on:keydown="NumbersOnly"
                              label="شماره تلفن "
                              v-model="item.phone" background-color="white" :disabled="!is_editing"/>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field class="rounded-lg"
                              label="توکن API "
                              v-model="item.api_token" background-color="white" :disabled="true"/>

              </v-col>
            </v-row>

            <v-row v-if="item.id">
              <v-col :cols="isXs?12:4">
                <label> رنگ اصلی</label>
                <v-color-picker
                    elevation="0"
                    v-model="item.primary_business_color">
                </v-color-picker>
              </v-col>
              <v-col :cols="isXs?12:4">
                <label> رنگ ثانویه</label>
                <v-color-picker
                    elevation="0"
                    v-model="item.secondary_business_color">
                </v-color-picker>
              </v-col>
              <v-col :cols="isXs?12:4">
                <label> رنگ تم</label>
                <v-color-picker
                    elevation="0"
                    v-model="item.theme_business_color">
                </v-color-picker>
              </v-col>
            </v-row>


            <v-row>
              <v-col cols="12">
                <v-textarea label=" درباره کسب و کار" rows="3"
                            v-model="item.about_us" background-color="white" class="rounded-lg"
                            :disabled="!is_editing"/>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-textarea label=" آدرس کسب و کار" rows="3"
                            v-model="item.address" background-color="white" class="rounded-lg"
                            :disabled="!is_editing"/>
              </v-col>
            </v-row>
            <v-card-actions>
              <v-row no-gutters class="d-flex flex-column-reverse flex-md-row mt-5">
                <v-col cols="12" md="6" class="d-flex justify-center justify-md-start mt-2 mt-md-0">
                </v-col>
                <v-col cols="12" md="6" class="d-flex justify-center justify-md-end">
                  <v-btn
                      v-if="is_editing"
                      @click="submitItem"
                      depressed
                      color="success"
                      class="w-100px white--text rounded-lg"
                  >
                      <span>
                        ثبت
                      </span>
                  </v-btn>
                  <v-btn
                      v-else
                      @click="is_editing=true"
                      depressed
                      color="warning"
                      class="w-100px white--text rounded-lg"
                  >
                      <span>
                        ویرایش
                      </span>
                  </v-btn>

                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-hover>

      </v-col>
    </v-row>
    <v-row justify="center">
      <v-dialog
          v-model="change_logo_dialog"
          class="rounded-lg"
          persistent
          @click:outside="change_logo_dialog=false"
          max-width="400"
      >
        <v-card class="rounded-lg pa-2">
          <v-card-title class="primary--text text-h5">
            تغییر لوگو کسب و کار
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="12">
                <m-file-input
                    label="انتخاب لوگو"
                    v-model="logo"
                    :delete-attachment.sync="delete_logo"
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="error"
                text
                @click="change_logo_dialog = false"
            >
              بستن
            </v-btn>
            <v-btn
                color="success"
                text
                @click="updateLogo(item)"
            >
              تغییر لوگو
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>


  </div>

</template>

<script>

import {MFormMixin} from "@/components/m-form";
import FormsMixin from "@/mixin/forms";
import {PathLevels, VisitorLevels} from "@/variables";
import formsMixin from "@/mixin/forms";
import money from "@/components/mcomponents/cleave/Money";
import Time from "@/components/mcomponents/cleave/Time";
import StoreSelect from "@/components/selects/StoreSelect";
import CurrencySelect from "@/components/selects/CurrencySelect";
import SupplierSelect from "@/components/selects/SupplierSelect";
import UserSelect from "@/components/selects/UserSelect";


export default {
  name: "AffiliateBusiness",
  components: {UserSelect, SupplierSelect, CurrencySelect, StoreSelect, Time},
  mixins: [MFormMixin, formsMixin, FormsMixin],
  props: {
    id: {},
  },
  data() {
    return {
      url: "main/business/all",
      filters: {},
      row_type: null,
      row_currency: null,
      row_number: null,
      addRowDialog: false,
      is_editing: true,
      excelRows: [],
      item: {},
      package_table: null,
      delete_logo: null,
      logo: null,
      upload_file_dialog: false,
      addInCaseOfSAleToAllRowsDialog: false,
      inCaseOfSaleType: null,
      inCaseOfSaleValue: null,
      change_logo_dialog: false,
      discountType: null,
      discountValue: null,
      entrance_file: null,
      delete_entrance_file: null,
      BUSINESS_TYPE: [
        {name: ' فروشگاه اینترنتی', value: 'om'},
        {name: 'فروشنده پورسانتی', value: 'cs'},
        {name: 'فروشگاه نمایندگی', value: 'rm'},
      ],
    };
  },
  computed: {
    title() {
      if (this.user.business_token) {
        return 'شخصی سازی'
      } else {
        return 'ثبت کسب و کار'

      }
    },
  },
  updated() {
  },
  created() {
    if(this.user.business_token){
      this.getAdminBusiness()
      this.is_editing = false
    }
    if (this.id) {
      this.getItem()
      this.is_editing = false
    }
  },
  watch: {
    id() {
      if (this.id) {
        this.getItem()
      }
    }
  },
  methods: {
    getItem() {
      this.request({
        url: this.endpoint(`main/business/${this.id}`),
        method: "get",
        success: data => {
          this.item = data
        }
      })
    },
    getAdminBusiness() {
      this.request({
        url: this.endpoint(`main/businessByToken/${this.user.business_token}`),
        method: "get",
        success: data => {
          this.item = data
          this.changeRouteTo(data.id)
        }
      })
    },
    submitItem() {
      if (this.id) {
        this.request({
          url: this.endpoint(`main/business/${this.id}`),
          method: "put",
          data: this.item,
          success: data => {
            this.item = data
            this.changeRouteTo(data.id)
            this.is_editing = false
            this.successNotify();
          }
        })

      } else {
        this.request({
          url: this.endpoint(`main/business`),
          method: "post",
          data: this.item,
          success: data => {
            this.item = data
            this.changeRouteTo(data.id)
            this.is_editing = false
            this.
            this.successNotify();
          }
        })
      }


    },
    newForm() {
      this.item = {}
      this.is_editing = true
      this.changeRouteTo(null)
    },
    getUpdateLogoSerialized() {
      let item = {
        id: this.id,
        logo: this.logo,
        delete_logo: this.delete_logo,
      };

      if (typeof item["logo"] == typeof "") {
        delete item["logo"];
      }

      return this.jsonToFormData(item);
    },

    updateLogo(selectItem) {
      this.request({
        url: this.endpoint(`main/businessLogoUpdate/${this.id}`),
        method: "put",
        data: this.getUpdateLogoSerialized(),
        success: (data) => {
          this.successNotify();
          this.is_editing = false;
          this.change_logo_dialog = false
          this.getItem()
        },
      });
    },

  },
}
</script>

<style scoped lang="scss">
.glass-effect {
  transition: backdrop-filter 0.5s ease;
  background-color: rgba(230, 230, 230, 0.2);
  backdrop-filter: blur(
          5px
  );
}

.glass-effect-hover {
  transition: backdrop-filter 0.5s ease;
  background-color: rgba(230, 230, 230, 0.2);
  backdrop-filter: blur(20px);
}

.cursor-pointer {
  cursor: pointer !important;
}

</style>

